import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCategory } from "../../store/actions/category";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import style from "../../thema/style";
class Navigation extends Component {
  componentDidMount() {
    this.props.fetchCategory();
  }
  state = { menu: false };

  render() {
    return (
      <nav className="row">
        <div className="col-md-12">
          <div className={"container"}>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  {!(window.innerWidth > 576) && (
                    <li>
                      <Link
                        to={"#"}
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState(({ menu }) => ({ menu: !menu }));
                        }}
                      >
                        <div
                          style={{
                            cursor: "pointer",
                            border: "1px solid #fff",
                            borderRadius: 5,
                            padding: "5px 10px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", this.state.menu ? "times" : "bars"]}
                          />
                        </div>
                      </Link>
                    </li>
                  )}
                  {this.props.category.categories.map((category, i) => {
                    return (
                      <li
                        key={i}
                        style={{
                          display:
                            window.innerWidth > 576
                              ? "inline-block"
                              : this.state.menu
                              ? "block"
                              : "none",
                        }}
                      >
                        <Link
                          to={{
                            pathname: `/kategori/${category.slug}`,
                            state: { category: category },
                          }}
                          onClick={() => {
                            this.setState({ menu: false });
                          }}
                          className={
                            (category.style.color || category.style.bg) &&
                            "category-style"
                          }
                          // className={style.categoryStyle}
                          style={{
                            "--category-color": category.style.color,
                            "--category-bg": category.style.bg,
                          }}
                          // style={Object.assign(
                          //   {},
                          //   ...[
                          //     category.style &&
                          //       (category.style.color !== "" ||
                          //         category.style.bg !== "") && {
                          //         "font-weight": "bold",
                          //       },
                          //     category.style && category.style.color
                          //       ? { "--category-color": category.style.color }
                          //       : {},
                          //     category.style && category.style.bg
                          //       ? { "--category-bg": category.style.bg }
                          //       : {},
                          //   ]
                          // )}
                        >
                          {category.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = ({ category }) => {
  return { category };
};

const mapDispatchToProps = {
  fetchCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/shared/Navigation.js